import getFormattedTime from "@/modules/calendar/utils/get-formatted-time"
import type { DailyCalendarEvent, DailyEvent, DailyExceeded } from "../../entities/daily-calendar"
import getEventCategoryInfo from "@/modules/calendar/utils/get-event-category-info"
import ActivitiesWeeklyCard from "../activities/weekly/activities-weekly-card"
import { ChevronRight, PlusCircle } from "lucide-react"
import { Card } from "@/components/ui/card"

interface DailyCaledarCustomEventProps {
  event: DailyCalendarEvent
  onClickActivitiesExceeded: () => void
}

export default function DailyCaledarCustomEvent({
  event,
  onClickActivitiesExceeded,
}: DailyCaledarCustomEventProps) {
  if (event.dailyCalendarEventType === "exceeded") {
    return <ExceededActivitiesCard event={event} onClick={onClickActivitiesExceeded} />
  } else if (event.dailyCalendarEventType === "event") {
    return <EventCard event={event} />
  } else {
    return <ActivitiesWeeklyCard {...event} canHideCard={false} isDailyCalendar={true} />
  }
}

const EventCard: React.FC<{ event: DailyEvent }> = ({ event }) => {
  const time = `${getFormattedTime(event.startDate, 12)} - ${getFormattedTime(event.endDate, 12)}`

  return (
    <div className="pointer-events-none relative z-[5] h-full cursor-default overflow-hidden rounded-sm border-l-[6px] border-solid border-l-neutral-400 bg-neutral-300 p-3">
      <div className="flex flex-col gap-3">
        <p className="flex w-full items-center gap-2">
          <span>{getEventCategoryInfo(event.parent.category).icon}</span>
          <span className="text-sm text-neutral-700">{event.parent.title}</span>
        </p>
        <p className="text-xs text-neutral-500">{time}</p>
      </div>
    </div>
  )
}

const ExceededActivitiesCard: React.FC<{ event: DailyExceeded; onClick: () => void }> = ({
  event,
  onClick,
}) => {
  return (
    <Card
      className="flex cursor-pointer select-none flex-col gap-2 rounded-l-md border-l-4 border-l-emerald-600 bg-emerald-50 p-3"
      onClick={onClick}
    >
      <div className="flex items-center text-gray-700">
        <h2 className="text-xs font-medium">📌 Actividades pendientes</h2>
      </div>

      <button className="flex items-center text-xs font-bold text-emerald-700">
        <PlusCircle className="mr-1 !size-6" />
        {event.count} Actividades
      </button>

      <button className="flex items-center text-xs font-medium text-emerald-700">
        Ver lista completa
        <ChevronRight className="ml-1 !size-4" />
      </button>
    </Card>
  )
}
